import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { toast } from 'react-toastify';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Joyride from 'react-joyride';
import {
  Table,
  Card,
  Button,
  Modal,
  Row,
  Col,
  Typography,
  Alert,
  Tag,
  Space,
  Tooltip,
  Result,
  Divider
} from 'antd';
import {
  DownloadOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  GiftOutlined,
  SaveOutlined
} from '@ant-design/icons';

import { obterItensTipoFTab, editarItem, adicionarItem } from '../actions/ItemActions';
import { obterFormandosPeloContrato, editarCamposFormando } from '../actions/FormandoActions';
import { cadastrarAcao } from '../actions/AcaoActions';
import { adicionarItemFormando, removerItemFormando } from '../actions/ItemFormandoActions';
import { editarContrato, descobrirContrato, editarCamposContrato, obterContratoPeloUsuario } from '../actions/ContratoActions';
import EmailService from '../services/EmailService';
import TabelaDistribuicao from '../components/TabelaDistribuicao';

const { Title, Text, Paragraph } = Typography;
const { confirm } = Modal;

class DistribuirBrindes extends React.Component {
  state = {
    newData: [],
    colHeaders: [],
    itens: [],
    formandos: [],
    itemSelecionado: {},
    showModalInformacoes: false,
    showModalNotificacao: false,
    botaoFinalizar: false,
    quantidadeNegativa: false,
    run: false,
    qualDadoCarregar: "brinde",
    tab: ["brinde"],
    steps: [
      {
        content: <div><h3>Distribuição de Brindes</h3><p>Bem-vindo! Aqui você gerencia a distribuição dos brindes para os formandos.</p></div>,
        placement: 'center',
        target: '#itens-disponiveis'
      },
      {
        content: <div><h3>Produtos Contratados</h3><p>Visualize aqui todos os brindes disponíveis no seu contrato.</p></div>,
        placement: 'bottom',
        target: '.ant-table-wrapper'
      },
      {
        content: <div><h3>Tabela de Distribuição</h3><p>Defina aqui a quantidade de brindes para cada formando.</p></div>,
        placement: 'bottom',
        target: '.tableDistribuicao'
      },
      {
        content: <div><h3>Exportar/Baixar</h3><p>Baixe a planilha de distribuição se precisar.</p></div>,
        placement: 'bottom',
        target: '#btnBaixarTabelaDistribuicao'
      },
      {
        content: <div><h3>Concluir</h3><p>Ao terminar, não esqueça de finalizar a etapa clicando aqui.</p></div>,
        target: '#botaoFinalizarDistribuicao'
      }
    ]
  }

  async componentDidMount() {
    await this.props.descobrirContrato(this.props.usuario.tipo, this.usuarioEhFormando() ? this.props.numeroContrato : this.props.usuario.id).then(async () => {
      await this.carregarDados();
    });
  }

  async carregarDados() {
    let newData = [],
      formandos = [];

    await this.props.obterItensTipoFTab(this.props.contrato.id, this.state.tab);
    await this.props.obterFormandosPeloContrato(this.props.contrato.id);

    formandos = this.props.formandos;
    this.executarJoyride();

    formandos.map(formando => {
      let auxFormando = { id: formando.id, nome: formando.nome, itens: [] };
      this.props.itens.forEach((item, i) => {
        let auxItem = { id: 0, idProduto: item.id, produto: item.produto, quantidade: 0, preco: item.preco, valorAdendo: item.valorAdendo };

        if (formando.itens.length === 0) {
          auxItem.id = auxItem.id === 0 ? auxItem.id - i : auxItem.id;
        } else {
          formando.itens.forEach(itemFormando => {
            if (itemFormando.item === item.id && itemFormando.tipo === this.state.qualDadoCarregar) {
              auxItem.id = itemFormando.id;
              auxItem.quantidade = itemFormando.quantidade;
            } else {
              auxItem.id = auxItem.id === 0 ? auxItem.id - i : auxItem.id;
            }
          });
        }

        auxFormando.itens.push(auxItem);
      });
      newData.push(auxFormando);
    });

    this.setState({ newData, itens: this.props.itens, formandos }, () => {
      this.atualizarColHeaders();
    });
  }

  executarJoyride() {
    if (localStorage.getItem("tutorialDistribuicaoBrindes") === null) {
      this.setState({ run: true });
      localStorage.setItem("tutorialDistribuicaoBrindes", true);
    }
  }

  atualizarColHeaders() {
    let index = 0,
      newData = this.state.newData,
      quantidadeNegativa = false,
      colHeaders = this.props.itens.map((item) => {
        let texto = `Item ${++index}`,
          quantidadeDisponivel = Number(item.quantidade);

        newData.forEach((formando) => {
          formando.itens.forEach((itemFormando) => {
            if (itemFormando.idProduto === item.id) {
              quantidadeDisponivel -= itemFormando.quantidade;
            }
          });
        });

        if (quantidadeDisponivel < 0) {
          quantidadeNegativa = true;
        }

        return { descricao: texto, qtd: quantidadeDisponivel, produto: item.produto };
      });

    if (quantidadeNegativa) {
      toast.error("Existem mais produtos distribuídos que contratados. Por favor, confirme a distribuição!");
    }

    this.setState({ colHeaders, quantidadeNegativa });
  }

  async atualizarDadosTabela(response) {
    switch (response.funcao) {
      case "remover":
        await this.props.removerItemFormando(response.item.id).then(async () => {
          await this.props.obterItensTipoFTab(this.props.contrato.id, this.state.tab).then(async () => {
            await this.props.obterFormandosPeloContrato(this.props.contrato.id).then(async () => {
              await this.carregarDados();
            });
          });
        });
        break;
      case "adicionar":
        await this.props.adicionarItemFormando(response.item).then(async () => {
          await this.props.obterItensTipoFTab(this.props.contrato.id, this.state.tab).then(async () => {
            await this.props.obterFormandosPeloContrato(this.props.contrato.id).then(async () => {
              await this.carregarDados();
            });
          });
        });
        break;
      case "atualizar":
        await this.props.obterItensTipoFTab(this.props.contrato.id, this.state.tab).then(async () => {
          await this.props.obterFormandosPeloContrato(this.props.contrato.id).then(async () => {
            await this.carregarDados();
          });
        });
        break;
      default:
        break;
    }
  }

  getQuantidadeItensDistribuidos(itemId) {
    let soma = 0;
    this.props.formandos.map(formando => {
      formando.itens.map(itemFormando => {
        if (itemFormando.item === itemId) {
          soma += itemFormando.quantidade;
        }
      });
    });
    return soma;
  }

  mostrarConfirmacaoFinalizar = () => {
    confirm({
      title: 'Finalizar Distribuição?',
      icon: <ExclamationCircleOutlined />,
      content: 'Ao confirmar, você declara que todos os brindes foram distribuídos corretamente e as quantidades foram verificadas.',
      okText: 'Confirmar',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: () => {
        this.finalizarDistribuicao();
      },
      onCancel() {
        console.log('Cancelado');
      },
    });
  }

  async finalizarDistribuicao() {
    let distribuiuTodos = true,
      { itens } = this.state;

    this.setState({ botaoFinalizar: true });

    itens.forEach(item => {
      if (item.observacao === "brinde") {
        let quantidade = (item.quantidade + item.adendo) - this.getQuantidadeItensDistribuidos(item.id);
        if (quantidade > 0) {
          distribuiuTodos = "Ainda existem produtos que não foram distribuídos!";
          return 0;
        } else if (quantidade < 0) {
          distribuiuTodos = "Existem produtos distribuídos que não foram contratados. Confirme as quantidades!";
          return 0;
        }
      }
    });

    // Se distribuiuTodos ainda é true (booleano), significa que passou nos testes
    // Se virou string, é a mensagem de erro.
    if (distribuiuTodos !== true) {
      toast.info(distribuiuTodos);
      this.setState({ botaoFinalizar: false });
    } else {
      let email = new EmailService(),
        acao = { ator: this.props.contrato.dono.id, texto: "Comissão distribuiu os itens brindes para o contrato " + this.props.contrato.numero, data: new Date(), contrato: this.props.contrato.id, tipo: "comissao", visualizado: false };
      email.enviar("updateAcaoComissaoToDesigner", { numero: this.props.contrato.numero, mensagem: "a distribuição de itens brinde", designer: { email: this.props.contrato.dono.email } });

      // Aguardar a atualização do contrato
      await this.props.editarCamposContrato(this.props.contrato.id, { distribuiuBrindes: 1 });

      // Recarregar o contrato atualizado
      await this.props.obterContratoPeloUsuario(this.props.contrato.usuario.id);

      this.props.cadastrarAcao(acao);
      this.setState({ botaoFinalizar: false, showModalNotificacao: true });
    }
  }

  baixarTabela() {
    let btn = document.querySelector("#btnBaixarTabela");

    if (btn) {
      btn.click();
    }
  }

  usuarioEhFormando() {
    return this.props.usuario.tipo === "formando";
  }

  formatarMoedaBR(valor) {
    if (valor) {
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    }
    return "0,00";
  }

  _renderAlerta() {
    if (this.props.contrato.distribuiuBrindes === 1) {
      return (
        <Alert
          message="Etapa Concluída"
          description="A distribuição de brindes foi finalizada com sucesso."
          type="success"
          showIcon
          icon={<CheckCircleOutlined />}
          style={{ marginBottom: 24, borderRadius: '8px' }}
        />
      );
    }
    return null;
  }

  _renderTabelaProdutos() {
    const { itens } = this.state;

    const columns = [
      {
        title: 'Produto',
        dataIndex: 'produto',
        key: 'produto',
        render: (text, record) => (
          <Space>
            <Text strong>{text}</Text>
            {record.ids && record.ids.split(";").length > 2 && (
              <Tag
                color="orange"
                style={{ cursor: 'pointer' }}
                onClick={() => this.setState({ itemSelecionado: record, showModalInformacoes: true })}
              >
                ver composição
              </Tag>
            )}
          </Space>
        ),
      },
      {
        title: 'Qtd. Contratada',
        dataIndex: 'quantidade',
        key: 'quantidade',
        align: 'right',
        render: (text) => <Text>{text}</Text>
      }
    ];

    return (
      <Card
        title={<Space><GiftOutlined /> Produtos Contratados</Space>}
        bordered={false}
        style={{ marginBottom: 24, boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderRadius: '8px' }}
      >
        <Table
          dataSource={itens}
          columns={columns}
          rowKey="id"
          pagination={false}
          size="middle"
          locale={{ emptyText: "O seu contrato não possui itens deste tipo para serem distribuídos!" }}
        />
      </Card>
    );
  }

  _renderTabelaDistribuicao() {
    return (
      <Card
        title="Tabela de Distribuição"
        bordered={false}
        style={{ marginBottom: 24, boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderRadius: '8px' }}
        extra={
          <Button
            id="btnBaixarTabelaDistribuicao"
            type="default"
            icon={<DownloadOutlined />}
            onClick={this.baixarTabela.bind(this)}
          >
            Baixar Planilha
          </Button>
        }
      >
        {/* Componente oculto para exportar Excel */}
        <ReactHTMLTableToExcel
          className="none"
          table="tabelaDistribuicaoItens"
          filename="Planilha de itens distribuidos"
          sheet="tablexls"
          id="btnBaixarTabela"
          buttonText="download"
          style={{ display: 'none' }}
        />

        {this.props.formandos.length > 0 ? (
          <div className="tableDistribuicao" style={{ display: "flex", flexDirection: "column" }}>
            <TabelaDistribuicao
              block={this.props.contrato.distribuiuBrindes !== 0}
              formatarMoedaBR={this.formatarMoedaBR}
              colHeaders={this.state.colHeaders}
              newData={this.state.newData}
              qualDadoCarregar={this.state.qualDadoCarregar}
              atualizarTabela={(response) => this.atualizarDadosTabela(response)}
            />
            {this.props.contrato.distribuiuBrindes === 0 && (
              <div style={{ marginTop: 24, textAlign: 'right' }}>
                <Button
                  id="botaoFinalizarDistribuicao"
                  type="primary"
                  danger
                  size="large"
                  icon={<SaveOutlined />}
                  loading={this.state.botaoFinalizar}
                  onClick={this.mostrarConfirmacaoFinalizar}
                  style={{ minWidth: '200px', height: '50px', fontSize: '16px', borderRadius: '6px' }}
                >
                  {this.state.botaoFinalizar ? "Finalizando..." : "Finalizar Etapa"}
                </Button>
              </div>
            )}
          </div>
        ) : (
          <Alert message="Será possível distribuir os itens quando existir, ao menos, 1 formando cadastrado." type="warning" showIcon />
        )}
      </Card>
    );
  }

  render() {
    if (this.usuarioEhFormando() || this.props.contrato.distribuiuBrindes === null) {
      return <Redirect to="./" />;
    }

    return (
      <div id="itens-disponiveis" style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>
        <Title level={2} style={{ marginBottom: 24 }}>Distribuição de Brindes</Title>

        {this._renderAlerta()}

        <Row gutter={24}>
          <Col xs={24} lg={8}>
            {this._renderTabelaProdutos()}
          </Col>
          <Col xs={24} lg={16}>
            {this.state.itens.length > 0 ? this._renderTabelaDistribuicao() : null}
          </Col>
        </Row>

        {/* Modal Notificação Sucesso */}
        <Modal
          visible={this.state.showModalNotificacao}
          onCancel={() => this.setState({ showModalNotificacao: false })}
          footer={null}
          centered
          width={600}
        >
          <Result
            status="success"
            title="Distribuição Finalizada!"
            subTitle="A distribuição de brindes foi salva. A próxima etapa é o cadastro das informações de faturamento."
            extra={[
              <a key="entrega" href="./entrega">
                <Button type="primary" size="large">
                  Ir para Faturamento/Entrega
                </Button>
              </a>
            ]}
          />
        </Modal>

        {/* Modal Informações do Item */}
        <Modal
          title="Detalhes do Produto"
          visible={this.state.showModalInformacoes !== false}
          onCancel={() => this.setState({ showModalInformacoes: false })}
          footer={[
            <Button key="close" onClick={() => this.setState({ showModalInformacoes: false })}>
              Fechar
            </Button>
          ]}
        >
          {this.state.itemSelecionado !== null && this.state.itemSelecionado.itens !== undefined ? (
            <div>
              <Title level={4}>Composição</Title>
              <ul>
                {this.state.itemSelecionado.itens.split(";").map((item, i) => (
                  item !== "" ? <li key={i}>{item}</li> : null
                ))}
              </ul>
            </div>
          ) : null}

          {this.state.itemSelecionado !== null && this.state.itemSelecionado.descricao !== undefined ? (
            <div>
              <Title level={4}>Produtos utilizados</Title>
              <ul>
                {this.state.itemSelecionado.descricao.split(" / ").map((descricao, i) => (
                  descricao !== "" ?
                    descricao.split(",").map((desc, j) => (
                      <li key={"desc" + i + j}>{desc}</li>
                    ))
                    : null
                ))}
              </ul>
            </div>
          ) : null}
        </Modal>

        <Joyride
          continuous={true}
          run={this.state.run}
          scrollToFirstStep={true}
          showProgress={true}
          showSkipButton={true}
          steps={this.state.steps}
          styles={{
            options: {
              zIndex: 10000,
              primaryColor: '#ff4d4f',
            },
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    itens: state.item.todosDistribuiveis,
    formandos: state.formando.todos,
    contrato: state.contrato.especifico,
    usuario: state.usuario.autenticado,
    numeroContrato: state.usuario.numeroContrato
  }
}

export default connect(mapStateToProps, {
  editarCamposContrato,
  editarCamposFormando,
  adicionarItem,
  editarItem,
  cadastrarAcao,
  removerItemFormando,
  adicionarItemFormando,
  obterFormandosPeloContrato,
  obterItensTipoFTab,
  editarContrato,
  obterContratoPeloUsuario,
  descobrirContrato
})(DistribuirBrindes);
